export default {
    methods: {
        getLastSequenceNumber(items) {
          let sequence = 0;
          for (let item of items) {
              if(item.ativo == true) {
                  if(item.sequenciaExibicao > sequence) {
                      sequence = item.sequenciaExibicao;
                  }
              }
          }
          return sequence;
        },
        getNextSequenceNumber(items) {
          return this.getLastSequenceNumber(items) + 1;
        },
        getSortedList(arrayObject) {
            if (arrayObject) {
                if (arrayObject.length > 0) {
                    return arrayObject
                        .filter((x) => x.ativo == true)
                        .sort((a1, a2) => a1.sequenciaExibicao - a2.sequenciaExibicao);
                }
            }
            return arrayObject;
        },
        setSequenceNumber(arrayObject, currentObject, newSequenceNumber) {
            newSequenceNumber = parseInt(newSequenceNumber);
            if (newSequenceNumber > currentObject.sequenciaExibicao) {
                this.setSequenceNumberUp(arrayObject, currentObject, newSequenceNumber);
            } else if (newSequenceNumber < currentObject.sequenciaExibicao) {
                this.setSequenceNumberDown(arrayObject, currentObject, newSequenceNumber);
            }
        },
        setSequenceNumberDown(arrayObject, currentObject, newSequenceNumber) {

            if (newSequenceNumber <= 0) {
                newSequenceNumber = 1;
            }
            
            let currentSequenceNumber = currentObject.sequenciaExibicao;

            let filteredObjects = arrayObject.filter(objectTemp =>
                objectTemp.sequenciaExibicao < currentSequenceNumber &&
                objectTemp.sequenciaExibicao >= newSequenceNumber
            );

            filteredObjects.forEach(objectTemp => {
                objectTemp.sequenciaExibicao++;
            });

            currentObject.sequenciaExibicao = newSequenceNumber;
        },
        setSequenceNumberUp(arrayObject, currentObject, newSequenceNumber) {

            let lastSequenceNumber = this.getLastSequenceNumber(arrayObject);
            if (newSequenceNumber > lastSequenceNumber) {
                newSequenceNumber = lastSequenceNumber;
            }

            let currentSequenceNumber = currentObject.sequenciaExibicao;

            let filteredObjects = arrayObject.filter(objectTemp =>
                objectTemp.sequenciaExibicao > currentSequenceNumber &&
                objectTemp.sequenciaExibicao <= newSequenceNumber
            );
            
            filteredObjects.forEach(objectTemp => {
                objectTemp.sequenciaExibicao--;
            });

            currentObject.sequenciaExibicao = newSequenceNumber;
        },
        updateIdWhenItGoesUp(arrayObject, currentObject) {
            this.setSequenceNumberDown(arrayObject, currentObject, currentObject.sequenciaExibicao - 1);
        },
        updateWhenGoDown(arrayObject, currentObject) {
            this.setSequenceNumberUp(arrayObject, currentObject, currentObject.sequenciaExibicao + 1);
        },
    }
}